export default {
  ['title']: 'COMPETITION NEWS',
  ['sub-title']: 'NOTIFICATIONS & UPDATES',
  ['action-notice']: 'Notice',
  ['action-advices']: 'Advices',
  ['action-history']: 'Previous works',
  ['events-history']: 'News of Previous Events'
}
